import React, { Fragment } from 'react';

import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import { reduxForm } from 'redux-form';
import classNames from 'classnames';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import i18n from '../../i18n';
import store from '../../store/redux_store';

import { setViewTab, setDetailViewTab } from '../../actions/ui';
import { addToCart, closeCartWidget, saveShirtToProfile } from '../../actions/general';
import { onDetailChanged } from '../../actions/render';
import {
  getSelectedAttrs,
  getSelectedFabric,
  getSelectedContrasts,
  getSelectedSize,
  recalculateShirtPrice,
  getShirtRemarks,
  getSelectedButtons,
} from '../../selectors/entities/general';

import { TagsInput, TagsInputItem } from "../ui/TagsInput";
import CartErrorModal from '../CartErrorModal';
import DeliveryIcon from '../icons/DeliveryIcon';
import GuaranteeIcon from '../icons/GuaranteeIcon';
import RubleLightIcon from '../icons/RubleLightIcon';

let START_WAITING_DAYS;

const WAITING_DAYS = 7;
const monthes = ['Januarys', 'Februarys', 'Marchs', 'Aprils', 'Mays', 'Junes', 'Julys', 'Augusts', 'Septembers', 'Octobers', 'Novembers', 'Decembers']

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 20px auto;
`;

const TextArea = styled.textarea`
    background-color: white;
    width: 100%;
    min-height: 50px;
    outline: gainsboro;
    border: 1px solid white;
    margin: 5px auto;
    padding: 15px;
    line-height: 13px;
    font-size: 13px;
    border-radius: 4px;
    letter-spacing: 2px;
`;

const Delivery = ({ items, date }) => {
  let fabricArt = items[0]['article'];
  
  if (!fabricArt.indexOf('Denim')) {
    START_WAITING_DAYS = 30;
  } else {
    START_WAITING_DAYS = 12;
  }
  const startDay = new Date(new Date().setDate(new Date().getDate() + START_WAITING_DAYS));
  const startDate = startDay.getDate();
  const startMonth = i18n.t(monthes[startDay.getMonth()]);

  const lastDay = new Date(new Date(startDay).setDate(startDay.getDate() + WAITING_DAYS));
  const lastDayDate = lastDay.getDate();
  const lastDayMonth = i18n.t(monthes[lastDay.getMonth()]);
  return (
    <div className='config-options-order__delivery_wrap flex'>
      <div className='config-options-order__delivery_date'>
        <DeliveryIcon
          size={24}
          color="currentColor"
          className='config-options-order__delivery_icon'
        />
        <div>
          Заказ будет доставлен:<br />
          c {startDate} {startMonth} по {lastDayDate} {lastDayMonth}
        </div>
      </div>

      <div className='config-options-order__delivery_guarantee'>
        <GuaranteeIcon
          size={24}
          color="currentColor"
          className='config-options-order__delivery_icon'
        />
        <div>
          Мы гарантируем нашим клиентам<br />
          превосходную посадку рубашки по фигуре.
        </div>
      </div>
    </div>
  )
}

const CommentBlock = ({ value, onChange }) => {
  return (
    <div className='config-options-order__comment_wrap mt-20 mb-20'>
      <div className='config-options-order__comment_label'>Комментарий к заказу:</div>
      <TextArea
        rows='3'
        className=''
        placeholder='Введите текст'
        value={value}
        onChange={(e) => { onChange(e.target.value, 'shirtRemarks') }}>
      </TextArea>
    </div>
  )
}

const ToggleBlock = ({ items, title, handleClick }) => {

  if (items.length === 0) {
    return null
  }

  return (
    <div className="flex bordered top bottom config-options-order__details_tag" >
      <div className="flex w-40 config-options-order__details_title">
        {title}
      </div>
      <div className="flex w-100 config-options-order__details_tags" >
        <TagsInput
          isExpanded
          type={'background'}
        >
          {items.map((d, i) => (
            <TagsInputItem
              key={i}
              value={d}
              onClick={() => { handleClick(d.keyValue) }}
              className={classNames(
                'config-options-order__tag',
                d.notValid ? 'config-options-order__tag_not-valid' : '')}
            >
              {d.displayName}
            </TagsInputItem>
          ))}
        </TagsInput>
      </div>
    </div>
  )
}

class BuilderProduct extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: null,
      errorModalOpened: false,
    }
  }

  addToCart = async () => {
    const { data } = await this.props.actions.addToCart();
    setTimeout(() => { this.props.actions.closeCartWidget() }, 5000);

    if (data && data.error_id) {
      this.setState({
        errorMessage: data.error_message,
        errorModalOpened: true,
      });
    }
  }

  saveShirt = async () => {
    await this.props.actions.saveShirtToProfile()
  }

  changeViewedTab = (value) => {
    store.dispatch(setViewTab(value))
  }

  changeDetailViewedTab = (value) => {
    this.changeViewedTab(1);
    store.dispatch(setDetailViewTab(value))
  }

  render() {

    const {
      parts,
      fabrics,
      sizes,
      shirtPrice,
      shirtRemarks,
      contrasts,
      buttons,
      isMobile,
      actions: { onDetailChanged },
    } = this.props

    const fabricKeys = Object.keys(fabrics);
    const selectedShirt = fabricKeys.length > 0 ? fabrics[fabricKeys[0]] : null;
    const title = 
    <Fragment>
      {selectedShirt ? selectedShirt.displayName : 'Ваша рубашка'}<br />
      {shirtPrice}&#160;<RubleLightIcon size={14} color='currentColor'/>
    </Fragment>;

    const normalizePart = (part) => {
      return typeof part === 'string' ? 
        { displayName: part, attrValue: part } : part;
    }


    let partsArr = [];
    for (var i in parts) {
      let clone = { ...parts[i] }
      if (['volume'].indexOf(i) != -1) {
        clone.keyValue = 'volume';
        partsArr.push(clone);
      } else if (['sleeve', 'cuffStyle', 'cuff', 'cuffDensity'].indexOf(i) != -1) {
        clone.keyValue = 'sleeve';
        partsArr.push(clone);
      } else if (['collar', 'collarDensity', 'collarButtons', 'collarBone'].indexOf(i) != -1) {
        clone.keyValue = 'collar';
        partsArr.push(clone);
      } else if (['fastening'].indexOf(i) != -1) {
        clone.keyValue = 'fastening';
        partsArr.push(clone);
      } else if (['pocket', 'pocketFlap', 'pocketButton'].indexOf(i) != -1) {
        clone.keyValue = 'pocket';
        partsArr.push(clone);
      } else if (['buttonThreadDecor'].indexOf(i) != -1) {
        clone.keyValue = 'buttons';
        partsArr.push(clone);
      } else if (['backPleats', 'collarDecor', 'cuffDecor', 'suspended'].indexOf(i) != -1) {
        clone.keyValue = 'backPleats';
        partsArr.push(clone);
      }
    }

    let buttonVal = Object.values(buttons).length ? Object.values(buttons)[0] : null;
    if(buttonVal) {
      buttonVal.keyValue = 'buttons';
      partsArr.push(buttonVal)
    }

    const monogramParts = [];
    for (let p in parts) {

      if ([
        'printProductNumber',
        'embroideryText',
        'embroideryFont',
        'embroideryColor',
        'embroidery'
      ].indexOf(p) != -1) {
        const part = normalizePart(parts[p]);
        monogramParts.push({
            ...part,
            keyValue: 'embroidery',
        });
      }
    }

    const contrastParts = [];
    for (let key in contrasts) {
      const contrastItem = contrasts[key];
      contrastParts.push({
        ...contrastItem,
        displayName: `${contrastItem.displayName} - ${contrastItem.shortName}`,
        keyValue: 'contrast',
      });
    }

    //const embroidery = parts.embroidery ? [{ ...parts.embroidery, keyValue: 'embroidery' }] : [];

    const sizeToggle = sizes ? [{ ...sizes }] : [{ displayName: 'Пожалуйста, укажите размер', notValid: true }];

    return (
      <section className="config-options-wrapper">
        <div className="config-options-content config-options-order p-20">

          <div className={classNames(
            "flex flex-row w-100 mb-20 justify-between",
            isMobile ? "" : "mt-10"
          )}>
            <p className="config-options-order__title">
              {title}
            </p>
          </div>

          {!sizes &&
            <label className="config-options-order__warning" onClick={() => { this.changeViewedTab(2) }}>
              Пожалуйста, укажите <u>размеры</u> до того как положить изделие в корзину.
            </label>
          }

          <ButtonWrapper>
            <button
              className="rit-button rit-button_theme_black rit-button_size_30em"
              onClick={this.addToCart}
              disabled={!sizes}
            >
              В корзину
              </button>
          </ButtonWrapper>

          <div className={classNames(
            "flex flex-column config-options-order__details",
            isMobile ? "w-100 mb-30" : "mb-10"
          )}>
            <ToggleBlock title={'Ткань'} items={Object.values(fabrics)} handleClick={() => { this.changeViewedTab(0) }} />
            <ToggleBlock title={'Детали'} items={partsArr} handleClick={(detailTab) => { this.changeDetailViewedTab(detailTab) }} />
            <ToggleBlock title={'Монограмма'} items={monogramParts} handleClick={(detailTab) => { this.changeDetailViewedTab(detailTab) }} />
            <ToggleBlock title={'Контрасты'} items={contrastParts} handleClick={(detailTab) => { this.changeDetailViewedTab(detailTab) }} />
            <ToggleBlock title={'Размер'} items={sizeToggle} handleClick={() => { this.changeViewedTab(2) }} />
          </div>

          <div className={classNames(
            "flex flex-column config-options-order__comment",
            isMobile ? "w-100" : "mb-20"
          )}>
            <CommentBlock value={shirtRemarks} onChange={onDetailChanged} />
          </div>

          <div className={classNames(
            "flex flex-column w-100 config-options-order__delivery",
            isMobile ? "mb-20" : "mt-20"
          )}>
            <Delivery items={Object.values(fabrics)} />
          </div>
        </div>

        <CartErrorModal
            title={'Не удалось добавить рубашку в корзину'}
            isOpened={this.state.errorModalOpened}
            onClose={() => this.setState({ errorModalOpened: false, errorMessage: null })}
            closeOnEsc={true}
            errorMessage={this.state.errorMessage}
        />
      </section>
    );
  }
}

BuilderProduct.propTypes = {
  parts: PropTypes.object.isRequired,
  fabrics: PropTypes.object.isRequired,
  sizes: PropTypes.object,
  shirtPrice: PropTypes.number.isRequired,
  shirtRemarks: PropTypes.string.isRequired,
  contrasts: PropTypes.object.isRequired,
  buttons: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  actions: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    parts: getSelectedAttrs(state),
    fabrics: getSelectedFabric(state),
    contrasts: getSelectedContrasts(state),
    sizes: getSelectedSize(state),
    shirtPrice: recalculateShirtPrice(state),
    shirtRemarks: getShirtRemarks(state),
    buttons: getSelectedButtons(state),
    isMobile: state.ui.isMobile,
  };
}


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ 
      addToCart,
      closeCartWidget,
      saveShirtToProfile,
      onDetailChanged
    }, dispatch)
  };
}


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(
  reduxForm({
    form: 'product',
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    enableReinitialize: true,
  })(BuilderProduct))
);
